import React from "react"
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view";
import FieldMultiselect_FormComponent from "../components/form/form-component";


export default function FieldMultiselect_FormElementView(props: FieldFormElementViewProps) {

    const value = props.field.getViewValue(props.model)

    return <FieldMultiselect_FormComponent
        field                = {props.field}
        // viewClasses          = {Classes("ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10", this.props.className)}
        className            = {props.className}
        value                = {value}
        disabled             = {props.disabled}
        onChange             = {props.onChange}
        onImmediateChange    = {props.onChange}/>

}